var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1276(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M290.764,838.37l636.417,0.227c0,0 222.311,-23.65 225.557,-242.832c3.416,-230.628 -238.965,-245.025 -245.501,-256.549c-48.543,-85.599 -81.545,-200.988 -294.416,-202.209c-263.675,-1.514 -301.222,308.44 -311.811,310.911c-79.699,18.595 -205.158,48.55 -203.824,212.436c1.337,164.262 193.578,178.016 193.578,178.016Z",
    style: {
      fill: "#525252"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287.652,431.8c-86.009,20.445 -210.605,57.956 -209.215,228.707c0.741,91.118 54.189,140.649 107.694,167.244c51.726,25.71 103.295,29.322 103.295,29.322c0.443,0.031 0.887,0.047 1.331,0.047l636.418,0.227c0.664,0 1.329,-0.035 1.99,-0.105c-0,-0 238.831,-25.573 242.321,-261.2c2.925,-197.448 -161.296,-247.851 -231.163,-266.007c-7.656,-1.99 -15.496,-4.156 -19.734,-5.345c-29.116,-52.467 -54.769,-113.94 -115.468,-156.038c-42.464,-29.451 -102.016,-49.877 -192.193,-50.395c-126.517,-0.726 -204.313,65.611 -252.531,139.25c-45.817,69.971 -64.255,146.511 -72.745,174.293Zm3.839,387.817c-5.484,-0.484 -47,-4.735 -88.669,-25.447c-42.95,-21.348 -86.291,-60.825 -86.886,-133.968c-1.229,-150.912 115.945,-176.901 189.335,-194.025c3.431,-0.801 9.682,-3.143 13.916,-11.594c2.303,-4.598 5.834,-17.095 11.007,-34.85c22.182,-76.142 83.16,-265.121 282.519,-263.977c80.121,0.46 133.308,17.544 171.037,43.711c57.547,39.911 79.31,99.857 107.178,148.999c1.487,2.622 4.325,6.238 9.931,8.991c4.481,2.201 15.185,5.014 30.032,8.872c60.707,15.776 205.64,57.599 203.099,229.158c-2.886,194.875 -193.136,222.508 -207.888,224.358c-0.014,0.002 -634.573,-0.224 -634.573,-0.224l-0.038,-0.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M646.915,682.817l-107.552,317.915l131.668,-89.375l-70.188,201.338",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1276);
export default __webpack_public_path__ + "static/media/1276.7502dd59c605dc7a3cd9bafa3293ae89.svg";
export { ForwardRef as ReactComponent };